import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';

import { ButtonModule } from '@hglobal/common';

import { SpinnerComponent } from '../spinner/spinner.component';
import { StatusIconComponent } from '../status-icon/status-icon.component';

@Component({
  selector: 'pp-common-info-dialog-content',
  imports: [StatusIconComponent, ButtonModule, SpinnerComponent],
  templateUrl: './info-dialog-content.component.html',
  styleUrl: './info-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogContentComponent {
  readonly title = input<string>();
  @Input() closeCaption: string;
  @Input() iconName?: string;
  readonly iconSize = input<'small' | 'large'>('small');
  readonly status = input<'danger' | 'success' | 'default'>();
  readonly discard = output();
}
